const STATUSES_C = ["Active", "Allotted", "Dropped", "On hold"];

// profiles.role values. "power" = Power user: approves (sanctions) clients.
const ROLES = ["agent", "power", "admin"];
const ROLE_LABEL = { agent: "Agent", power: "Power user", admin: "Admin" };
const canSanction = (role) => role === "admin" || role === "power";

const STATUSES_P = ["Available", "Reserved", "Under negotiation", "Allotted", "Sold", "On hold"];

const PRIORITIES = ["Low", "Medium", "High", "Urgent"];

const TYPES = ["Land", "House", "Land+House", "Apartment", "Commercial"];

const BUDGETS = [
    "0-5L",
    "5-10L",
    "10-15L",
    "15-20L",
    "20-25L",
    "25-30L",
    "30L+",
    "Per-cent",
    "Unspecified",
  ];

const SOURCES = ["Referral", "Walk-in", "Online", "Repeat", "Advertisement", "Other"];

const AMENITIES = [
    "Borewell",
    "Well",
    "Compound wall",
    "Gate",
    "Electricity",
    "Water connection",
    "Road frontage",
    "Corner plot",
    "Near temple",
    "Near school",
    "Near hospital",
    "Near bus stop",
    "Trees",
    "Garden",
    "Parking",
  ];

const sStyle = {
    Active: {
      dot: "bg-emerald-400",
      text: "text-emerald-200",
      bg: "bg-emerald-400/10",
      ring: "ring-emerald-400/20",
    },
    Allotted: {
      dot: "bg-sky-400",
      text: "text-sky-200",
      bg: "bg-sky-400/10",
      ring: "ring-sky-400/20",
    },
    Dropped: {
      dot: "bg-stone-400",
      text: "text-stone-300",
      bg: "bg-stone-400/10",
      ring: "ring-stone-400/20",
    },
    "On hold": {
      dot: "bg-amber-400",
      text: "text-amber-200",
      bg: "bg-amber-400/10",
      ring: "ring-amber-400/20",
    },
    Available: {
      dot: "bg-emerald-400",
      text: "text-emerald-200",
      bg: "bg-emerald-400/10",
      ring: "ring-emerald-400/20",
    },
    Reserved: {
      dot: "bg-violet-400",
      text: "text-violet-200",
      bg: "bg-violet-400/10",
      ring: "ring-violet-400/20",
    },
    "Under negotiation": {
      dot: "bg-amber-400",
      text: "text-amber-200",
      bg: "bg-amber-400/10",
      ring: "ring-amber-400/20",
    },
    Sold: {
      dot: "bg-rose-400",
      text: "text-rose-200",
      bg: "bg-rose-400/10",
      ring: "ring-rose-400/20",
    },
  };

const pStyle = {
    Low: {
      dot: "bg-stone-400",
      text: "text-stone-300",
    },
    Medium: {
      dot: "bg-sky-400",
      text: "text-sky-200",
    },
    High: {
      dot: "bg-amber-400",
      text: "text-amber-200",
    },
    Urgent: {
      dot: "bg-rose-400",
      text: "text-rose-200",
    },
  };

export { STATUSES_C, STATUSES_P, PRIORITIES, TYPES, BUDGETS, SOURCES, AMENITIES, sStyle, pStyle, ROLES, ROLE_LABEL, canSanction };
